import React, {Component} from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routing from '../src/component/routing/Routing';

class App extends Component{
  render() {
    return (
      <>
        <BrowserRouter>
          <Routing/>
        </BrowserRouter>
      </>
    )
  }
}

export default App;
